import { Button, Tooltip } from "@chakra-ui/react";
import React from "react";
import { FiDownload } from "react-icons/fi";
import { SkeletonRect } from "../../atoms/Skeletons";

export const BILLING_OWNER_REQUIRED_MESSAGE =
  "Please contact the billing owner to upgrade the account and unlock this feature";

export function ActionOrPurchaseButton({
  canPurchase,
  hasActionPermission,
  blockAction,
  blockedText,
  isLoading,
  handleAction,
  handlePurchase,
  inProgress,
  actionText,
}: {
  canPurchase: boolean;
  hasActionPermission: boolean;
  blockAction: boolean;
  blockedText: string;
  isLoading: boolean | undefined;
  handleAction: () => void;
  handlePurchase: () => void;
  inProgress: boolean | undefined;
  actionText?: string;
}) {
  const text =
    hasActionPermission ? (actionText ?? "Download")
    : canPurchase ? "Unlock"
    : "Locked";

  return (
    <Tooltip
      shouldWrapChildren
      label={
        blockAction ? blockedText
        : !hasActionPermission && !canPurchase ?
          BILLING_OWNER_REQUIRED_MESSAGE
        : undefined
      }
    >
      <SkeletonRect isLoaded={!isLoading}>
        <Button
          variant="outline"
          colorScheme="gray"
          leftIcon={text === "Download" ? <FiDownload /> : undefined}
          size="sm"
          isDisabled={blockAction || (!hasActionPermission && !canPurchase)}
          onClick={hasActionPermission ? handleAction : handlePurchase}
          isLoading={inProgress}
          cursor={
            blockAction || (!hasActionPermission && !canPurchase) ?
              "no-drop"
            : undefined
          }
        >
          {text}
        </Button>
      </SkeletonRect>
    </Tooltip>
  );
}
